import { AsyncPipe, DOCUMENT, DecimalPipe, NgStyle } from '@angular/common';
import {
    Component,
    HostListener,
    Inject,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { MatBadge } from '@angular/material/badge';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
    MatProgressSpinner,
    ProgressSpinnerMode,
} from '@angular/material/progress-spinner';
import { MatTooltip } from '@angular/material/tooltip';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import {
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
    NgbTooltip,
} from '@ng-bootstrap/ng-bootstrap';
import { CommentsDialogComponent } from 'app/core/components/popup/comments-dialog/comments-dialog.component';
import { UserImagePipe } from 'app/core/pipes/user-image.pipe';
import { AlertSettingsService } from 'app/global-services/alerts.service';
import { EventManagerService } from 'app/global-services/event-manager.service';
import { PopupService } from 'app/global-services/popup.service';
import { ForumService } from 'app/products/bi/services/forum.service';
import { productForDashboard } from 'app/products/config/dashboardProductMap';
import { MONTH_NAMES_LONG } from 'app/shared/utils/shared-constants.utils';
import { abortUnsubscribe } from 'app/shared/utils/shared-methods.utils';
import { Subject, Subscription } from 'rxjs';
import { PRODUCT_THEMES } from 'shared/core/config/product-theme.config';
import { PulseProduct, VALID_PRODUCTS } from 'shared/core/config/product.types';
import { DashboardService } from 'shared/core/services/dashboard.service';
import { EntityService } from 'shared/core/services/entity.service';
import { GlobalService } from 'shared/core/services/global.service';
import { ImportLoadStatusService } from 'shared/core/services/import-load-status.service';
import { ProductService } from 'shared/core/services/product.service';
import { SecurityService } from 'shared/core/services/security/security.service';
import { ServerService } from 'shared/core/services/server.service';
import { SupportService } from 'shared/core/services/support.service';
import { TenantService } from 'shared/core/services/tenant/tenant.service';
import { ThemeService } from 'shared/core/services/theme.service';
import { UserService } from 'shared/core/services/user/user.service';
import { HAS_ENTITY_SIDEBAR } from 'shared/interfaces/shared-interfaces';
import { DashboardAccess, User } from 'shared/interfaces/UserInterface';
import { getLogoPath, isCompanyLHG, isCompanyRHG } from 'shared/utils/tenant.utils';
import { AvatarComponent } from '../../core/components/avatar/avatar.component';
import { UnwrapTagDirective } from '../directives/unwrap-tag.directive';
import { EntitySideBarService } from '../entity-sidebar/entity-sidebar.service';
import { MenuSectionComponent } from './menu-section/menu-section.component';
import { PioneerBadgeComponent } from './star-rating/star-rating.component';
const RC_CORP_DASHBOARD_ID = 'rate-controller-corp';
declare let mLayout: any;
@Component({
    selector: 'dashboard-header-nav',
    templateUrl: './dashboard-header-nav.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./dashboard-header-nav.component.scss'],
    imports: [
        UnwrapTagDirective,
        RouterLink,
        MatProgressSpinner,
        MatTooltip,
        AsyncPipe,
        UserImagePipe,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu,
        AvatarComponent,
        NgbDropdownItem,
        MenuSectionComponent,
        MatIconButton,
        NgbTooltip,
        NgStyle,
        MatBadge,
        MatIcon,
        PioneerBadgeComponent,
        DecimalPipe,
        TranslocoModule,
    ],
})
export class DashboardHeaderNavComponent implements OnInit, OnDestroy {
    /**
     * True once the page has scrolled away from the top. Drives the drop shadow
     * under .m-header__top, so the bar only lifts off the page when there is
     * content passing underneath it.
     */
    protected isScrolled = false;

    @HostListener('window:scroll')
    protected onWindowScroll(): void {
        const scrolled = (this.document.scrollingElement?.scrollTop ?? 0) > 4;

        if (scrolled !== this.isScrolled) {
            this.isScrolled = scrolled;
        }
    }

    protected isCompanyRHG = isCompanyRHG;
    protected isCompanyLHG = isCompanyLHG;
    protected getLogoPath = getLogoPath;
    public news;
    public formattedToday;
    public numberOfNews;
    public todayNews;
    public menu: any;
    public user: User;
    public info: any;
    public updateUnread = 0;
    public allowedHtlIds: number[] = [];
    protected subscriptions: Subscription[] = [];
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    // Computed property for logo visibility based on tenant config
    public get hideLHGLogo(): boolean {
        return !isCompanyLHG();
    }
    // Multi-tenancy properties
    public tenantLogo: string = '';
    public tenantName: string = '';
    // Progress spinners

    protected isForumRoute = false;
    public pinnedDashboards: any[] = [];
    public supportAvailable = true;
    public supportIntro = false;
    private supportIntroTimers: ReturnType<typeof setTimeout>[] = [];
    private supportIntroCleanup: (() => void) | null = null;
    private static readonly SUPPORT_INTRO_SESSION_KEY = 'pulse.supportIntro.shown';
    /** Set of dashboard IDs allowed for the current product. Null = no filtering (legacy). */
    private productFeatureIds: Set<string> | null = null;
    /** Set of common dashboard IDs (product_id=0). Used to visually separate common menus. */
    private commonFeatureIds: Set<string> | null = null;
    /** Common menu groups shown after the product-specific ones, separated by an <hr>. */
    public commonMenu: any;
    public homeRoute: string;
    public homeHref: string;

    /** Product switcher items for the sidebar navigation strip */
    public productSwitcherItems: Array<{
        product: PulseProduct;
        displayName: string;
        icon: string;
        accentColor: string;
        hasAccess: boolean;
        isCurrent: boolean;
        url: string;
    }> = [];

    private static readonly PRODUCT_ICONS: Record<PulseProduct, string> = {
        insight: 'insights',
        plan: 'calendar_month',
        pro: 'workspace_premium',
        rate: 'price_change',
        shift: 'swap_horiz',
        ant: 'handshake',
        tks: 'timer',
    };

    mode: ProgressSpinnerMode = 'determinate';
    value_rooms = 0;
    value_me = 0;
    rooms_tooltip = 'Rooms load status for your current hotel selection: 0%';
    me_tooltip = 'ME load status for your current hotel selection : 0%';
    selectedDashboardId: string | null = null;
    constructor(
        public entityService: EntityService,
        private userService: UserService,
        private serverService: ServerService,
        private popupService: PopupService,
        public router: Router,
        private eventManagerService: EventManagerService,
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        public themeService: ThemeService,
        public globalService: GlobalService,
        private dashboardService: DashboardService,
        public alertsService: AlertSettingsService,
        public tenantService: TenantService,
        private securityService: SecurityService,
        public productService: ProductService,
        public forumService: ForumService,
        private sidebar: EntitySideBarService,
        private importLoadStatusService: ImportLoadStatusService,
        private supportService: SupportService,
        @Inject(HAS_ENTITY_SIDEBAR) public hasSidebar: boolean
    ) {
        this.ngUnsubscribe = new Subject<void>();
        console.log(this.userService.user, 'test');
        this.user = this.userService.user;
        this.homeRoute = '/' + this.productService.getHomeRoute();
        this.homeHref = this.homeRoute;
    }
    public ngOnInit(): void {
        // Tab visibility handling for the load status is now in ImportLoadStatusService
        this.subscriptions.push(
            this.importLoadStatusService.loadStatus$.subscribe(status => {
                this.value_rooms = status.rooms;
                this.rooms_tooltip =
                    'Rooms load status for your current hotel selection: ' +
                    status.rooms +
                    '%';
                this.value_me = status.me;
                this.me_tooltip =
                    'ME load status for your current hotel selection : ' +
                    status.me +
                    '%';
            })
        );
        this.subscriptions.push(
            this.router.events.subscribe(() => {
                const bodyNode = this.document.getElementsByTagName('body')[0];
                if (this.themeService.mode === 'dark') {
                    this.renderer.removeClass(bodyNode, 'theme--default');
                    this.renderer.addClass(bodyNode, 'theme--dark');
                } else {
                    this.renderer.removeClass(bodyNode, 'theme--dark');
                    this.renderer.addClass(bodyNode, 'theme--default');
                }
            })
        );
        this.getNewDevelopments();
        // The load status is not fetched here: at this point the user session may
        // not be resolved yet, and a 401 from this background poll used to tear the
        // session down. It is now triggered from _registerChanges() once the user is
        // ready (on_ready is a BehaviorSubject, so it fires immediately if already true).
        this._registerChanges();
        this.getPinnedDashboards();
        this.pinnedDashboards = (this.userService.user?.pinned || []).map(
            p => p.dashboard_id
        );

        this.subscriptions.push(
            this.eventManagerService.subscribe('dashboardSwitch', response => {
                this.allowedHtlIds = response.data;
            })
        );
        this.subscriptions.push(
            this.eventManagerService.subscribe('selectedEntityUpdate', _response => {
                // Note: the load status is NOT refreshed from here.
                // This event is broadcast by selectAllEntities() before selectedHtlId has been updated, so refreshing on it would read a stale selection
                // ImportLoadStatusService subscribes to EntityService.on_change/on_selectAll instead, which fire after selectedHtlId is set
                this.pickRandomPointsMessage();
            })
        );

        this.subscriptions.push(
            this.router.events.subscribe(event => {
                if (event instanceof NavigationEnd) {
                    this.isForumRoute = event.urlAfterRedirects.includes('/forum');
                }
            })
        );

        this.importLoadStatusService.start();
        this.startSupportIntro();
    }

    public checkForUpdates(): void {
        const monthNames = MONTH_NAMES_LONG;

        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = monthNames[today.getMonth()];
        const year = today.getFullYear().toString();
        this.formattedToday = day + ' ' + month + ' ' + year;
    }

    public getNumberOfNewAlerts(data): void {
        this.numberOfNews = 0;
        for (const element of data) {
            if (element.news_date === this.formattedToday) {
                this.numberOfNews += 1;
            }
        }
    }

    public getIcon(data): void {
        for (const element of data) {
            element.icon = 'fiber_new';
            element.color = 'rgb(38, 128, 189)';
        }
    }

    public getNewDevelopments(): void {
        // 🚪 Block API calls if session is invalid or logout is in progress
        if (!this.serverService.shouldMakeApiCalls()) {
            console.log(
                '🚪 [DashboardHeader] Skipping getNewDevelopments - session invalid or logout in progress'
            );
            return;
        }

        this.serverService.get(
            'dashboard/summary' + '/getNewDevelopments',
            {},
            (data: any) => {
                const decoded = data.map(el => this.securityService.decodeFormData(el));
                this.checkForUpdates();
                this.getNumberOfNewAlerts(decoded);
                this.getIcon(decoded);
                decoded.map(element =>
                    element.news_date === this.formattedToday
                        ? (element.isNew = true)
                        : (element.isNew = false)
                );
                const transformedData = decoded.reduce((acc, curr) => {
                    const existingDashboard = acc.find(
                        item => item.dashboard === curr.dashboard
                    );
                    if (existingDashboard) {
                        existingDashboard.children.push(curr);
                    } else {
                        acc.push({ dashboard: curr.dashboard, children: [curr] });
                    }

                    return acc;
                }, []);

                this.news = transformedData;
            },
            err => {
                console.error(err);
            },
            this.ngUnsubscribe,
            true
        );
    }

    public init(dashboards: any[]): void {
        if (dashboards == null) return;

        // Filter dashboards by product features if available
        const filtered = this.productFeatureIds
            ? dashboards.filter(d => this.productFeatureIds.has(d.id))
            : dashboards;

        if (this.productFeatureIds) {
            const excluded = dashboards.filter(d => !this.productFeatureIds.has(d.id));
            console.log(
                '[ProductFilter] total=' + dashboards.length,
                'filtered=' + filtered.length,
                'excluded IDs=',
                excluded.map(d => d.id)
            );
        }

        this.dashboardSearch = '';
        const menus: Array<DashboardCategory> = [];
        let menu_name = '';
        let cpt = -1;
        for (let i = 0; i < filtered.length; i++) {
            const d = filtered[i];
            if (menu_name != d['menu_name']) {
                menu_name = d['menu_name'];
                cpt++;
                menus[cpt] = {
                    label: menu_name,
                    name: d['menu_id'],
                    has_presentation: false,
                    has_commercial_plan: false,
                    show_badge: false,
                    children: [],
                };
            }
            if (d.type === 'Custom Presentations') menus[cpt].has_presentation = true;
            if (d.type === 'Settings') menus[cpt].has_presentation = true;
            if (d.type === 'Commercial Plan') menus[cpt].has_commercial_plan = true;
            // For News item (first position of the array), we switch show_badge to true.
            menus[0].show_badge = true;
            menus[cpt].children.push(d);
        }

        for (const menu of menus) {
            menu.children.forEach((d: DashboardAccess) => {
                // Not necessarily the product being viewed: a dashboard listed
                // here may be routed under another one (Revenue Mapping lives
                // in planRoutes but shows under Mapping Admin from Insights).
                // Stamping the current product produced links that 404.
                d.product = productForDashboard(d.id, this.productService.product);
            });
        }

        // Split menus into product-specific and common groups
        if (this.commonFeatureIds && this.commonFeatureIds.size > 0) {
            const productMenus: Array<DashboardCategory> = [];
            const commonMenus: Array<DashboardCategory> = [];
            for (const menuGroup of menus) {
                const allCommon = menuGroup.children.every((d: DashboardAccess) =>
                    this.commonFeatureIds.has(d.id)
                );
                if (allCommon) {
                    commonMenus.push(menuGroup);
                } else {
                    productMenus.push(menuGroup);
                }
            }
            this.menu = productMenus;
            this.commonMenu = commonMenus;
        } else {
            this.menu = menus;
            this.commonMenu = [];
        }
        this.initializeMenuExpansion();
        console.log(this.menu);
        setTimeout(() => {
            mLayout.initHeader();
            $('a[data-bs-toggle=collapse]').on('click', function () {
                // swap chevron
                $(this).children('i').toggleClass('fa-chevron-down fa-chevron-right');
            });
            $('a.list-group-item.m-menu__link').on('click', function () {
                // close menu
                $(this)
                    .closest('li.m-menu__item--open-dropdown.m-menu__item--hover')
                    .removeClass('m-menu__item--open-dropdown m-menu__item--hover');
            });
        }, 500);
        if (this.userService.user && this.serverService.shouldMakeApiCalls()) {
            this.serverService.get(
                'access/getUpdateRead',
                {
                    user: this.userService.user.user_id,
                    update: 'updateRead1',
                },
                (data: { CT: number }[]) => {
                    if (!data[0].CT) this.updateUnread = 1;
                }
            );
        }
    }
    public openSupport(): void {
        this.endSupportIntro();
        this.supportService.open();
    }

    private startSupportIntro(): void {
        const win = this.document.defaultView;
        if (!win?.matchMedia) return;
        if (!win.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 993px)').matches) {
            return;
        }

        try {
            if (win.sessionStorage.getItem(DashboardHeaderNavComponent.SUPPORT_INTRO_SESSION_KEY)) {
                return;
            }
            win.sessionStorage.setItem(DashboardHeaderNavComponent.SUPPORT_INTRO_SESSION_KEY, '1');
        } catch {
            return;
        }

        const reduceMotion = win.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.supportIntroTimers.push(
            setTimeout(() => {
                this.supportIntro = true;
                const stop = (): void => this.endSupportIntro();
                const events = ['pointerdown', 'keydown', 'wheel', 'touchstart'];
                events.forEach(e => win.addEventListener(e, stop, { capture: true, passive: true }));
                this.supportIntroCleanup = () =>
                    events.forEach(e => win.removeEventListener(e, stop, { capture: true }));
                this.supportIntroTimers.push(
                    setTimeout(() => this.endSupportIntro(), reduceMotion ? 5000 : 4000)
                );
            }, 1500)
        );
    }

    private endSupportIntro(): void {
        this.supportIntroTimers.forEach(t => clearTimeout(t));
        this.supportIntroTimers = [];
        this.supportIntroCleanup?.();
        this.supportIntroCleanup = null;
        this.supportIntro = false;
    }

    openQuickSideBar(): void {
        this.sidebar.open();
    }
    public openCommentsDialog(): void {
        if (this.info.error) {
            // Do something?
        } else {
            this.popupService.open(
                CommentsDialogComponent as Component,
                undefined,
                node => {
                    // Go to dashboard
                    this.router.navigateByUrl(
                        '/dashboard/' + node.dashboard_id + '#' + node.section_id
                    );
                },
                () => {
                    this._getInfo();
                },
                'xl'
            );
        }
    }

    private _registerChanges(): void {
        this.subscriptions.push(
            this.userService.on_ready.subscribe(ready => {
                if (ready) {
                    this.user = this.userService.user;
                    this.loadProductFeatures(() => {
                        this.init(this.userService.user.dashboards);
                    });
                    this.loadUserProducts();
                    // Only fetch the import status once the session is confirmed.
                    // refresh() is TTL- and selection-deduped, so repeated
                    // on_ready emissions cannot cause a burst of calls like the
                    // loop issue I had today (20260731)
                    this.importLoadStatusService.refresh();
                }
            })
        );
    }

    /**
     * Load the list of dashboard IDs allowed for the current product from the backend.
     * Falls back to no filtering (legacy mode) if the endpoint is unavailable.
     */
    private loadProductFeatures(callback: () => void): void {
        if (!this.serverService.shouldMakeApiCalls()) {
            callback();
            return;
        }
        this.serverService.get(
            'product/getFeatures',
            { product: this.productService.product },
            (data: { features: string[]; common: string[] }) => {
                console.log(
                    '[ProductFeatures] product=' + this.productService.product,
                    'features=',
                    data?.features,
                    'common=',
                    data?.common
                );
                if (data && data.features && data.features.length > 0) {
                    this.productFeatureIds = new Set(data.features);
                    this.commonFeatureIds =
                        data.common && data.common.length > 0
                            ? new Set(data.common)
                            : null;
                } else {
                    this.productFeatureIds = null; // no filtering
                    this.commonFeatureIds = null;
                }
                callback();
            },
            _err => {
                // Endpoint not available yet — no filtering (backward compatible)
                this.productFeatureIds = null;
                this.commonFeatureIds = null;
                callback();
            },
            this.ngUnsubscribe,
            true
        );
    }
    /**
     * Load which products the current user has access to, for the product switcher strip.
     */
    private loadUserProducts(): void {
        if (!this.serverService.shouldMakeApiCalls()) return;
        this.serverService.get(
            'product/getAllProducts',
            {},
            (data: Array<{ product: string; hasAccess: boolean }>) => {
                this.productSwitcherItems = VALID_PRODUCTS.map(p => {
                    const match = data.find(
                        d => d.product.toLowerCase() === p.toLowerCase()
                    );
                    const hasAccess = match?.hasAccess || false;
                    const isCurrent = p === this.productService.product;
                    return {
                        product: p,
                        displayName: PRODUCT_THEMES[p].displayName.replace('Pulse ', ''),
                        icon: DashboardHeaderNavComponent.PRODUCT_ICONS[p] || 'apps',
                        accentColor: PRODUCT_THEMES[p].accentColor,
                        hasAccess,
                        isCurrent,
                        url: isCurrent
                            ? ''
                            : hasAccess
                              ? this.productService.getProductUrl(p)
                              : window.location.origin,
                    };
                });
            },
            err => {
                console.error('[ProductSwitcher] Failed to load user products:', err);
            },
            this.ngUnsubscribe,
            true
        );
    }

    private _getInfo(): void {
        // Block API calls if session is invalid or logout is in progress
        if (!this.serverService.shouldMakeApiCalls()) {
            console.log(
                '🚪 [DashboardHeader] Skipping _getInfo - session invalid or logout in progress'
            );
            return;
        }

        abortUnsubscribe(this.ngUnsubscribe);
        this.serverService.post(
            'reader-comments-tool/info',
            {},
            (data: any) => {
                this.info = data;
            },
            error => {
                console.error(error);
                this.info = { badge: 0, error: error };
            },
            this.ngUnsubscribe,
            true
        );
    }
    public ngOnDestroy(): void {
        this.endSupportIntro();
        abortUnsubscribe(this.ngUnsubscribe, true);
        for (const sub of this.subscriptions) {
            sub.unsubscribe();
        }
        this.importLoadStatusService.stop();
    }
    public getNumberOfSelectedHotels(): string {
        const _selectedHotels = this.entityService?.selectedHtlId.filter(htl =>
            this.allowedHtlIds.includes(htl)
        );
        return _selectedHotels.length.toString();
    }

    /**
     * The Rate product has two dashboards: one for a single hotel and one for a group of
     * hotels.
     * Send the user to the one that matches the current hotel selection, because
     * the two dashboards call different backend endpoints.
     */
    public getSwitcherUrl(item: { product: PulseProduct; url: string }): string {
        if (item.product !== 'rate') return item.url;
        if (Number(this.getNumberOfSelectedHotels()) <= 1) return item.url;
        const _hasCorpAccess = (this.userService.user?.dashboards || []).some(
            (d: any) => d.id === RC_CORP_DASHBOARD_ID
        );
        if (!_hasCorpAccess) return item.url;
        return `${window.location.origin}/products/rate/dashboard/${RC_CORP_DASHBOARD_ID}`;
    }

    public switchTheme(theme: string): void {
        this.themeService.themeChanged$.next(theme);
    }
    public openImportControl(): void {
        this.router.navigate(['/products/insight/dashboard/import-control']);
    }
    public getSpinnerColor(value: number): string {
        if (value < 50) {
            return 'warn';
        }
        if (value < 80) {
            return 'accent';
        }
        return 'primary';
    }

    togglePin(dashboardId: number): void {
        const isPinned = this.pinnedDashboards.includes(dashboardId);
        const userId = this.userService.user.user_id;

        const action$ = isPinned
            ? this.dashboardService.unpinDashboard(userId, dashboardId)
            : this.dashboardService.pinDashboard(userId, dashboardId);

        action$.subscribe({
            next: () => {
                if (isPinned) {
                    this.pinnedDashboards = this.pinnedDashboards.filter(
                        id => id !== dashboardId
                    );
                } else {
                    this.pinnedDashboards.push(dashboardId);
                }
            },
            error: err => console.error('Error toggling pin:', err),
        });
    }

    public dashboardSearch = '';

    public get searchableDashboards(): any[] {
        const dashboards = [...(this.menu || []), ...(this.commonMenu || [])]
            .flatMap(group => group.children || [])
            .filter(item => item.type === 'Dashboards');
        return dashboards.filter(
            (item, index, all) =>
                all.findIndex(
                    other => other.id === item.id && other.product === item.product
                ) === index
        );
    }

    public get dashboardSearchResults(): any[] {
        const query = this.dashboardSearch.trim().toLocaleLowerCase();
        return this.searchableDashboards.filter(item =>
            item.name?.toLocaleLowerCase().includes(query)
        );
    }

    public updateDashboardSearch(event: Event): void {
        this.dashboardSearch = (event.target as HTMLInputElement).value;
    }

    openMenuItemName: string | null = null;

    private initializeMenuExpansion(): void {
        this.openMenuItemName = this.menu?.length === 1 ? this.menu[0].name : null;
    }

    toggleMenuItem(name: string): void {
        this.openMenuItemName = this.openMenuItemName === name ? null : name;
    }

    getPinnedDashboards(): any[] {
        if (!this.menu) return [];
        const allDashboards = this.menu.flatMap(item => item.children || []);
        return allDashboards.filter(
            d =>
                this.pinnedDashboards.includes(d.id) &&
                (!this.productFeatureIds || this.productFeatureIds.has(d.id))
        );
    }

    closeOffCanvas(): void {
        ($('.offcanvas') as any).offcanvas('hide');
    }

    private pointsMessages: string[] = [
        'Nothing stops a real Pulser.',
        'Points tell the story of your commitment.',
        'Building your Pulse journey, one point at a time.',
        'Every action counts.',
        'Consistency beats intensity.',
        'Your dedication powers Pulse forward.',
        'Each point is proof of your impact.',
        'Momentum today, leadership tomorrow.',
        'Pulse legends are built with consistency.',
        'Great insights start with small actions.',
        'You’re shaping the future of Pulse.',
        'The leaderboard is waiting for you.',
        'Push a little further, go a little higher.',
        'Keep the momentum.',
        'Step by step, point by point.',
        'Your journey inspires others.',
        'Small actions, big impact.',
        'Progress looks good on you.',
        'Stay curious, stay consistent.',
        'One point closer to greatness.',
        'Pulse is energy, and you’re charging it',
        'Charles would be proud of those points.',
        'If Charles saw this, he’d say “not bad, eh?”.',
        'Charles-approved progress right here.',
        'Careful… Charles is catching up on the leaderboard.',
    ];

    public pointsMessage: string = '';

    private pickRandomPointsMessage(): void {
        if (!this.pointsMessages?.length) {
            this.pointsMessage = '';
            return;
        }
        const last = this.pointsMessage;
        let idx = Math.floor(Math.random() * this.pointsMessages.length);
        if (this.pointsMessages.length > 1 && this.pointsMessages[idx] === last) {
            idx = (idx + 1) % this.pointsMessages.length;
        }
        this.pointsMessage = this.pointsMessages[idx];
    }

    onUserMenuOpen(isOpen: boolean): void {
        if (isOpen) {
            this.pickRandomPointsMessage();
        }
    }

    openLeaderboard(event: MouseEvent, drop?: any): void {
        event.stopPropagation();
        drop?.close?.();
        this.router.navigate(['/products/insight/dashboard/leaderboard']);
    }

    goToIndex(): void {
        this.router.navigate(['/products/insight/dashboard/index']);
    }

    hideOffcanvas(): void {
        (window as any).$('.offcanvas').offcanvas('hide');
    }
}
export interface DashboardCategory {
    label: string;
    name: string;
    has_presentation: boolean;
    has_commercial_plan: boolean;
    show_badge: boolean;
    children: Array<DashboardAccess>;
}
